// extracted by mini-css-extract-plugin
export default {"imageBasic":"styles_imageBasic__N0m9l"};